import { format } from 'date-fns'
export function saveCSVFromBlob (blob: Blob, dateFrom: Date, dateTo: Date): void {
  const dateFormat = 'yyyy-MM-dd'
  const filename = `statistic_summary_export_${format(dateFrom, dateFormat).toString()}_${format(dateTo, dateFormat).toString()}.csv`
  const content = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), blob], {
    type: 'text/csv;encoding:utf-8',
  })

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE doesn't allow using a blob object directly as link href.
    // Workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(content, filename)
    return
  }

  const blobURL = window.URL.createObjectURL(content)
  const tempLink = document.createElement('a')

  tempLink.style.display = 'none'
  tempLink.href = blobURL
  tempLink.setAttribute('download', filename)

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank')
  }

  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(blobURL)
  }, 100)
}
